export const COUPON_FORM = 'coupon';
export const COUPON_ASSIGNED_MERCHANTS_FORM = 'couponAssignedMerchants';

export const COUPON_QUANTITY = 'COUPON_QUANTITY';
export const MERCHANT_QUANTITY = 'MERCHANT_QUANTITY';

export const MONTHLY_SUBSCRIPTION_LENGTH = 'MONTHLY';
export const ANNUAL_SUBSCRIPTION_LENGTH = 'ANNUAL';
